import { nextStep } from 'New/redux/actions/actions';
import React from 'react';
import { connect } from 'react-redux';

const ViewMobileWarningModal = (props) => {
    const buttonStyle = {
        fontWeight: "600",
        color: "#6a6a6a",
        width: "80%",
        margin: "0 auto",
        border: "none",
        boxShadow: "2px 2px #ccc",
        width: "40%",
        borderRadius: "5px",
    }

    return props.showViewMobileWarningModal && (
        <div className='WarningModal' style={{
            padding: "20px",
            display: "flex",
        }}>
            <p>
                Have you checked the mobile player?
            </p>
            <img src='/static/public/img/mobile-phone-monochrome.png'
                style={{
                    height: '50%',
                    objectFit: 'contain',
                }}/>
            <p>Please check every level before you publish.</p>
            <div style={{
                display: "flex",
                justifyContent: "space-around",
            }}>
                <button style={buttonStyle}
                    onClick={() => { props.setShowViewMobileWarningModal(false) }}>
                    Dismiss
                </button>
                <button style={{
                    ...buttonStyle,
                    background: "#FF9300",
                    color: "#fff",
                }}
                    onClick={() => {
                        props.save();
                        props.nextStep("portrait scale layout", '_');
                    }}>
                    View Mobile
                </button>
            </div>
        </div>
    );
};

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
    }
}

export default connect(null, putActions)(ViewMobileWarningModal);